export const PAINEL_URL = "https://painel.sendcube.com.br";

const WHATSAPP_NUMBER = "5511960006625";

export function whatsappLink(message: string): string {
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
}

export const DEFAULT_WHATSAPP_MESSAGE =
  "Ola! Quero saber mais sobre a SendCube pra disparar campanhas no WhatsApp.";
